import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useTranslation } from 'react-i18next';
import DashboardTab from "./DashboardTab";
import AvailabilitiesTab from "./AvailabilitiesTab";
import ScheduleTab from "./ScheduleTab";
import ClientsTab from "./ClientsTab";
import SalesTab from "./SalesTab";
import { jwtDecode } from "jwt-decode";

const CoachDashboard = () => {
  const { t, i18n } = useTranslation();
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("dashboard");
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
  
    if (!token) {
      setRole("unauthenticated");
      setLoading(false);
      return;
    }
  
    try {
      const decoded = jwtDecode(token);
      const { role } = decoded;
      setRole(role);
    } catch (error) {
      console.error("Invalid token:", error);
      setRole("unauthenticated");
    } finally {
      setLoading(false);
    }
  }, []);

  if (loading) return <p>Loading...</p>;

  if (role !== "coach" && role !== "admin") {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <h2>You are not a coach!</h2>
        <p>
          <button onClick={() => navigate("/")}>Go back to main page</button>
          <br />
          <button onClick={() => navigate("/login")}>Login as coach</button>
        </p>
      </div>
    );
  }
  const handleReturnHome = () => {
    navigate("/");
  };
  
  const handleSignOut = () => {
    localStorage.clear();
    navigate("/");
  };
  const switchLanguage = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("language", lang);
  };

  const renderContent = () => {
    switch (activeTab) {
      case "dashboard":
        return <DashboardTab />;
      case "availabilities":
        return <AvailabilitiesTab />;
      case "schedule":
        return <ScheduleTab />;
      case "clients":
        return <ClientsTab />;
      case "sales":
        return <SalesTab />;
      default:
        return <DashboardTab />;
    }
  };

  return (
    <DashboardContainer>
      <Sidebar>
        <MenuItem onClick={handleReturnHome}>{t('CDmenu.return')}</MenuItem>
        <MenuItem onClick={() => setActiveTab("dashboard")}>{t('CDmenu.dashboard')}</MenuItem>
        <MenuItem onClick={() => setActiveTab("availabilities")}>{t('CDmenu.availabilities')}</MenuItem>
        <MenuItem onClick={() => setActiveTab("schedule")}>{t('CDmenu.schedule')}</MenuItem>
        <MenuItem onClick={() => setActiveTab("clients")}>{t('CDmenu.clients')}</MenuItem>
        <MenuItem onClick={() => setActiveTab("sales")}>{t('CDmenu.sales')}</MenuItem>
        <MenuItem onClick={handleSignOut}>{t('CDmenu.signout')}</MenuItem>
        <LanguageSwitcher>
        <span>
          <button onClick={() => switchLanguage('fr')}>FR</button>/ 
          <button onClick={() => switchLanguage('en')}>EN</button>
        </span>
      </LanguageSwitcher>
      </Sidebar>
      <Content>
        {renderContent()}
      </Content>
    </DashboardContainer>
  );
};

export default CoachDashboard;

const DashboardContainer = styled.div`
  display: flex;
  min-height: 100vh;
`;

const Sidebar = styled.div`
  width: 220px;
  background-color:rgba(148,163,135,1);
  padding: 20px;
  color: white;
`;

const MenuItem = styled.div`
  margin: 15px 0;
  cursor: pointer;
  padding: 10px;
  border-radius: 5px;

  &:hover {
    background-color:rgba(186,204,171,1);
  }
`;

const Content = styled.div`
  flex: 1;
  padding: 40px;
  background-color: #f7f9fc;
`;
const LanguageSwitcher = styled.div`
  top: 40px;
  color: white;
  width: 130px;
  button {
    color: white;
    font-size: 15px;
    border:none;
    padding: 5px 5px;
    cursor: pointer;
    background-color: transparent;
    border-radius: 30px;
    &:hover {
      background-color:rgba(186,204,171,1);
    }
  }
`;